module.exports = __webpack_public_path__ + "assets/not-qualified-screen-icon.ef82c51b.svg";